import { render, staticRenderFns } from "./CalendarListItem.vue?vue&type=template&id=b848ec00&scoped=true"
import script from "./CalendarListItem.vue?vue&type=script&lang=js"
export * from "./CalendarListItem.vue?vue&type=script&lang=js"
import style0 from "./CalendarListItem.vue?vue&type=style&index=0&id=b848ec00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b848ec00",
  null
  
)

export default component.exports